"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/RightToolbar/index.vue"));
var _ActInfo = _interopRequireDefault(require("./components/ActInfo.vue"));
var _ActRecord = _interopRequireDefault(require("./components/ActRecord.vue"));
var _applet = require("@/api/operation/applet");
var _signChallenge = require("@/api/marketing/sign-challenge");
var _enums = require("./enums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    RightToolbar: _index.default,
    ActInfo: _ActInfo.default,
    ActRecord: _ActRecord.default
  },
  data: function data() {
    return {
      loading: false,
      appList: [],
      infoOptions: {
        show: false,
        id: ''
      },
      recordOptions: {
        show: false,
        id: ''
      }
    };
  },
  computed: {
    formData: function formData() {
      return [{
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }, {
        label: '活动名称',
        prop: 'title',
        defaultValue: '',
        type: 'input'
      }, {
        label: '活动状态',
        prop: 'status',
        defaultValue: '',
        type: 'select',
        options: {
          list: _enums.statusOptions
        }
      }
      // { label: '创建时间', prop: 'createTime', defaultValue: [], type: 'datetimeRange', options: { startKey: 'createTimeStart', endKey: 'createTimeEnd', startPlaceholder: '开始时间', endPlaceholder: '结束时间' } },
      ];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 70
      }, {
        key: 'title',
        visible: true,
        label: "\u6D3B\u52A8\u540D\u79F0",
        width: 160
      }, {
        key: 'applicationName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528",
        width: 160
      }, {
        key: 'continuousDays',
        visible: true,
        label: "\u6253\u5361\u5929\u6570",
        width: 80,
        formatter: 'text',
        formatOptions: {
          list: _enums.continuousDaysTypeOptions
        }
      }, {
        key: 'renewType',
        visible: true,
        label: "\u7EED\u7B7E\u65B9\u5F0F",
        width: 80,
        formatter: 'text',
        formatOptions: {
          list: _enums.renewTypeOptions
        }
      }, {
        key: 'renewTimes',
        visible: true,
        label: "\u7EED\u7B7E\u6B21\u6570",
        width: 160
      }, {
        key: 'sort',
        visible: true,
        label: "\u6392\u5E8F",
        width: 100
      }, {
        key: 'status',
        visible: true,
        label: "\u72B6\u6001",
        width: 90
      }, {
        key: 'updateTime',
        visible: true,
        label: "\u66F4\u65B0\u65F6\u95F4",
        width: 160
      }, {
        key: 'updateUser',
        visible: true,
        label: "\u64CD\u4F5C\u4EBA",
        width: 100
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      (0, _applet.appletListApi)(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    refreshList: function refreshList() {
      this.$refs.searchPage && this.$refs.searchPage.refresh();
    },
    resetList: function resetList() {
      this.$refs.searchPage && this.$refs.searchPage.resetSearch();
    },
    getList: function getList(query) {
      return (0, _signChallenge.signChallengeListApi)(query).then(function (res) {
        var list = (res.list || []).map(function (item) {
          return item;
        });
        return {
          list: list,
          total: res.total
        };
      });
    },
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/marketing/sign-challenge/operate/0/add"
      });
    },
    //操作
    handleItem: function handleItem(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/sign-challenge/operate/".concat(row.id, "/").concat(operate)
      });
    },
    handleActData: function handleActData(row) {
      this.infoOptions.id = row.id;
      this.infoOptions.show = true;
    },
    handleRecord: function handleRecord(row) {
      this.recordOptions.id = row.id;
      this.recordOptions.show = true;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _signChallenge.signChallengeDeleteApi)(row.id);
      }).then(function () {
        _this2.refreshList();
        _this2.$modal.msgSuccess('删除成功');
      });
    },
    //修改状态
    handleStatusChange: function handleStatusChange(row) {
      var params = {
        id: row.id,
        status: row.status
      };
      this.loading = true;
      // aiPromptStatusChangeApi(params)
      //   .then((res) => {
      //     this.loading = false;
      //     this.$message.success('更新状态成功');
      //   })
      //   .catch(() => {
      //     this.loading = false;
      //     this.$message.error('更新状态失败');
      //     row.bannerFlag = row.bannerFlag === 1 ? 2 : 1;
      //   });
    }
  }
};